// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"
import type { DataReturnType, DetailType as ReturnDetailType } from "pages/Sales/Transaction/ReturnRecord/types"

// Utils
import { useApi } from "utils"

// Types
interface DataType {
  approve_by: number | null
  approve_status: number
  refund_return_id: number
  return_id: number
  memo: string
  referensi: string
  transaction_date: string
  trx_code: string
  detail: {
    qty_return_item: string
    qty_unit: string
    product_id: number
  }[]
}
interface ReturnDataType {
  datareturn: DataReturnType,
  detailreturn: ReturnDetailType[]
}
type Type = DataType | null
type ReturnType = ReturnDataType | null

export function useDetail(refund_return_id?: string): {
  data: Type
  isLoading: boolean
  returnData: ReturnType
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<Type>(null)
  const [isLoading, setLoading] = useState<boolean>(true)
  const [returnData, setReturnData] = useState<ReturnType>(null)

  // Functions
  const handleError = (): void => {
    setData(null)
    setReturnData(null)
    setLoading(false)
  }

  useEffect(() => {
    api.get(
      "/received/detail_refund_return",
      { params: { refund_return_id } }
    ).then((res: SuccessFetch<{
      payload: DataType
    }>) => {
      // Vars
      const payload = res.data.payload

      setData(payload)

      api.get(
        "/return/detailreturn",
        { params: { return_id: payload.return_id } }
      ).then((res: SuccessFetch<{
        payload: ReturnDataType
      }>) => {
        setReturnData(res.data.payload)
        setLoading(false)
      }).catch(() => {
        handleError()
      })
    }).catch(() => {
      handleError()
    })

    return () => {
      setReturnData(null)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading, returnData }
}